module.exports = __webpack_public_path__ + "static/media/P1010307.6d85d184.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/P1010307.JPG
// module id = 189
// module chunks = 0